"use strict";

module.exports = indexOf;
function indexOf(val, obj) {
  return obj != null && obj.indexOf ? obj.indexOf(val) : -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/indexOf/indexOf.js
// module id = 426
// module chunks = 0